module.exports = __webpack_public_path__ + "static/media/movimagen.45a12810.png";